/**
 * Newsletter form schema. Matches `apps/api/src/schemas/validation.ts`
 * (`subscribeSchema`) — same shape, same Arabic error messages.
 */

import { z } from 'zod'

export const newsletterSchema = z.object({
  email: z.string().email('البريد الإلكتروني غير صحيح'),
  name: z.string().max(100).optional(),
  /** Cloudflare Turnstile token. Required in production; optional locally. */
  turnstileToken: z.string().optional(),
})

export type NewsletterInput = z.infer<typeof newsletterSchema>
